var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeminiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 8.00899 15.993 8.01643 15.984 8.017C13.9141 8.14792 11.9628 9.02923 10.496 10.496C9.02923 11.9628 8.14792 13.9141 8.017 15.984C8.01643 15.993 8.00899 16 8 16C7.99101 16 7.98357 15.993 7.98301 15.984C7.85229 13.9141 6.97105 11.9626 5.5042 10.4958C4.03736 9.02895 2.08593 8.14771 0.0159847 8.01699C0.00701216 8.01643 0 8.00899 0 8C0 7.99101 0.0070121 7.98357 0.0159847 7.98301C2.08593 7.85229 4.03736 6.97105 5.5042 5.5042C6.97105 4.03736 7.85229 2.08593 7.98301 0.0159855C7.98357 0.00701244 7.99101 0 8 0C8.00899 0 8.01643 0.00701143 8.017 0.0159837C8.14792 2.08586 9.02923 4.03716 10.496 5.50397C11.9628 6.97077 13.9141 7.85208 15.984 7.983C15.993 7.98357 16 7.99101 16 8Z",
    fill: "url(#paint0_radial_1692_207)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1692_207",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.588 6.503) rotate(18.6832) scale(17.03 136.421)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#9168C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#5684D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#1BA1E3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeminiIcon);
export default __webpack_public_path__ + "static/media/geminiIcon.2a06f47c.svg";
export { ForwardRef as ReactComponent };